import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import nudgeKeys from 'actions/nudges/queryKeys';
import { useQuery } from 'react-query';
import api from 'utils/api';
import filterObject from 'utils/filterObject';
import { getPageOffset } from 'utils/pagination';
function formatNudgeData(item) {
  var _item$nudge, _item$nudge$nudgeActi, _item$nudge2, _item$nudge3, _item$nudge4, _item$nudge5, _item$nudge6, _filteredScheduledDat, _item$nudge7, _item$nudge8, _item$nudge9, _item$nudge10, _item$nudge11, _item$nudge12, _item$nudge12$nudgeTe;
  var filteredScheduledDates = (_item$nudge = item.nudge) === null || _item$nudge === void 0 ? void 0 : (_item$nudge$nudgeActi = _item$nudge.nudgeAction) === null || _item$nudge$nudgeActi === void 0 ? void 0 : _item$nudge$nudgeActi.filter(function (action) {
    return action.scheduled_date !== null;
  });
  var formattedNudge = {
    id: (_item$nudge2 = item.nudge) === null || _item$nudge2 === void 0 ? void 0 : _item$nudge2.id,
    name: (_item$nudge3 = item.nudge) === null || _item$nudge3 === void 0 ? void 0 : _item$nudge3.name,
    isEnabled: Boolean((_item$nudge4 = item.nudge) === null || _item$nudge4 === void 0 ? void 0 : _item$nudge4.isEnabled),
    goalType: (_item$nudge5 = item.nudge) === null || _item$nudge5 === void 0 ? void 0 : _item$nudge5.goalType,
    audience: (_item$nudge6 = item.nudge) === null || _item$nudge6 === void 0 ? void 0 : _item$nudge6.audience,
    scheduledDate: (filteredScheduledDates === null || filteredScheduledDates === void 0 ? void 0 : (_filteredScheduledDat = filteredScheduledDates[0]) === null || _filteredScheduledDat === void 0 ? void 0 : _filteredScheduledDat.scheduled_date) || undefined,
    targetDate: ((_item$nudge7 = item.nudge) === null || _item$nudge7 === void 0 ? void 0 : _item$nudge7.target_date) || undefined,
    targetOffset: (_item$nudge8 = item.nudge) === null || _item$nudge8 === void 0 ? void 0 : _item$nudge8.target_offset,
    targetOffsetUnit: (_item$nudge9 = item.nudge) === null || _item$nudge9 === void 0 ? void 0 : _item$nudge9.target_offset_unit,
    targetType: (_item$nudge10 = item.nudge) === null || _item$nudge10 === void 0 ? void 0 : _item$nudge10.target_type,
    isTargetDueDate: Boolean((_item$nudge11 = item.nudge) === null || _item$nudge11 === void 0 ? void 0 : _item$nudge11.is_target_due_date),
    nudgeTeamsIds: ((_item$nudge12 = item.nudge) === null || _item$nudge12 === void 0 ? void 0 : (_item$nudge12$nudgeTe = _item$nudge12.nudgeTeam) === null || _item$nudge12$nudgeTe === void 0 ? void 0 : _item$nudge12$nudgeTe.map(function (team) {
      return team.team_id;
    })) || undefined
  };
  return filterObject(formattedNudge);
}
export var CONTENT_NUDGES_PER_PAGE = 20;
export var useContentNudgeQuery = function useContentNudgeQuery(_ref) {
  var contentId = _ref.contentId,
    isEnabled = _ref.isEnabled,
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? CONTENT_NUDGES_PER_PAGE : _ref$limit,
    _ref$page = _ref.page,
    page = _ref$page === void 0 ? 1 : _ref$page;
  function fetchContentNudges() {
    return _fetchContentNudges.apply(this, arguments);
  }
  function _fetchContentNudges() {
    _fetchContentNudges = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var offset, listQuery, countQuery, _yield$Promise$all, _yield$Promise$all2, nudges, count, items, formattedItems, total;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            offset = getPageOffset({
              page: page,
              itemsPerPage: CONTENT_NUDGES_PER_PAGE
            });
            listQuery = {
              fields: [{
                nudge: ['id', 'name', 'isEnabled', 'goalType', 'audience', 'target_date', 'target_offset', 'target_offset_unit', 'target_type', 'is_target_due_date', {
                  nudgeTeam: ['team_id']
                }, {
                  nudgeAction: ['scheduled_date']
                }]
              }],
              filter: {
                content_id: contentId
              },
              limit: limit,
              start: offset
            };
            countQuery = {
              fields: {
                count: 'COUNT(DISTINCT id)'
              },
              filter: {
                content_id: contentId
              },
              limit: 10000,
              notfound: 0
            };
            _context.next = 5;
            return Promise.all([api('get', '/api/query/nudgeContent', listQuery), api('get', '/api/query/nudgeContent', countQuery)]);
          case 5:
            _yield$Promise$all = _context.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            nudges = _yield$Promise$all2[0];
            count = _yield$Promise$all2[1];
            items = nudges.items;
            formattedItems = items.map(formatNudgeData);
            total = count.items[0].count || 0;
            return _context.abrupt("return", {
              items: formattedItems,
              total: total
            });
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _fetchContentNudges.apply(this, arguments);
  }
  var _useQuery = useQuery(nudgeKeys.contentNudgeList(contentId, page), fetchContentNudges, {
      enabled: isEnabled
    }),
    data = _useQuery.data,
    isError = _useQuery.isError,
    isLoading = _useQuery.isLoading;
  return {
    items: (data === null || data === void 0 ? void 0 : data.items) || [],
    total: data === null || data === void 0 ? void 0 : data.total,
    isError: isError,
    isLoading: isLoading
  };
};
export default useContentNudgeQuery;